import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { SessionService } from '../../../shared/services/session.service';
import { ISolicitacaoConsultaFiltros, ESolicitacaoConsultaStatus } from '../../consultas/data/consultas';
import { ConsultasService } from '../../consultas/services/consultas.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html'
})
export class NavbarComponent {
  ERoleAdminString = ERoleAdminString;
  hasConsultasPendentes$!: Observable<Boolean>;
  menuAmount = 0;
  isAdmin = false;

  constructor(private readonly consultasService: ConsultasService, private readonly sessionService: SessionService) {}

  ngOnInit(): void {
    this.menuAmount = this.sessionService
      .getSession()
      .userdata.reduce((prev, curr) => prev + (curr.includes('list') ? 1 : 0), 0);
    this.isAdmin = this.sessionService.getSession().role === this.ERoleAdminString.Admin;

    this.hasConsultasPendentes$ = this.consultasService.hasConsultasPendentes$.asObservable();

    if (
      this.sessionService.getSession().role === ERoleAdminString.Doctor ||
      this.sessionService.getSession().userdata.includes('appointments.list')
    ) {
      this.carregarConsultas();
    }
  }

  carregarConsultas(): void {
    // const filtros: ISolicitacaoConsultaFiltros = {
    //   orderBy: EOrdenacao.MaisNovos,
    //   pageNumber: 0,
    //   pageSize: 1,
    //   doctorId: this.sessionService.getSession()!.sid!,
    //   periodStart: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
    //   periodEnd: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString(),
    //   status: Number(ESolicitacaoConsultaStatus.pendenteAprovacao)
    // };
    // this.consultasService.listarTodasSolicitacoesConsultas(filtros).subscribe((res) => {});
    //TODO: FUNÇÃO NÃO FAZENDO NADA
  }
}
